import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';

interface Props {
  deviceGroupName: string;
  onConfirm: () => Promise<void>;
}

const DeleteDeviceGroupModal: React.FC<Props> = ({ deviceGroupName, onConfirm }) => {
  const { translation } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    await onConfirm();
  };

  return (
    <ModalTemplate
      title={`${translation.delete} "${deviceGroupName}"?`}
      primaryAction={{
        id: 'confirm-delete-device-group-button',
        label: translation.delete,
        onClick: handleClick,
        dangerzone: true,
        loading: isLoading
      }}
      secondaryAction={{
        id: 'cancel-button',
        label: translation.cancel
      }}
    >
      <Stack spacing={3}>
        <Typography>
          {translation.are_you_sure_that_you_want_to_delete} &quot;{deviceGroupName}&quot;?{' '}
          {translation.any_access_rights_previously_assigned_will_be_revoked}
        </Typography>
      </Stack>
    </ModalTemplate>
  );
};

export default DeleteDeviceGroupModal;
